import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import Wizard from '@src/pages/wizard/wizard'

@Component
export default class MemberOnboarding extends Vue {

  // default step where to start the onboarding
  private startStep: number = 2

  constructor () {
    super()
  }

  closeBuilder () {
    this.$store.dispatch('changeStep', null)
    this.$router.push(`/trainers/platform/members/${this.$route.params.id}/status`)
  }

  render (h: CreateElement) {
    return <Wizard basePath={`/trainers/onboarding/${this.$route.params.id}`}
                   closeCallback={this.closeBuilder}
                   startStep={this.startStep} />
  }

  beforeMount () {
    if (this.$route.query && this.$route.query.startStep) {
      this.startStep = parseInt(this.$route.query.startStep, 10) || 2
    }
  }
}
